export function* takeWhere<T>(items: Iterable<T>, predicate: (item: T) => boolean, limit: number) {
  if (limit <= 0) {
    return;
  }

  let count = 0;

  for (const item of items) {
    if (predicate(item)) {
      yield item;

      if (++count >= limit) {
        return;
      }
    }
  }
}

export const flatMap = function* <T, R>(items: Iterable<T>, mapper: (item: T) => Iterable<R>): Generator<R> {
  for (const item of items) {
    yield* mapper(item);
  }
};
